import {ChangeDetectionStrategy, Component, HostListener, OnInit} from '@angular/core';
import {Store} from "@ngxs/store";
import {BehaviorSubject, Observable} from "rxjs";
import {PermissionService} from "../../../services";
import {MatDialog} from "@angular/material/dialog";
import {AppState, ChangeLanguage, LoadLanguages} from "../../../state";
import {Router} from "@angular/router";
import {Language} from "../../../services/api";
import {SubscriptionHandlerComponent} from "../../shared";

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToolbarComponent extends SubscriptionHandlerComponent implements OnInit{

    languages$: Observable<Language[]> = this.store.select(AppState.languages);

    language$: Observable<Language | null> = this.store.select(AppState.selectedLanguage);

    view$: Observable<string> = this.store.select(AppState.productView);

    screenHeight: number;
    screenWidth: number;

    constructor(public router: Router,
                public permissionService: PermissionService,
                private dialog: MatDialog,
                private store: Store) {
        super();
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize() {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    async ngOnInit(): Promise<void> {
        this.subscribeTo(this.permissionService.accessGranted$,x => {
            if (x) {
                this.store.dispatch(new LoadLanguages());
            }
        });

        this.getScreenSize();
    }

    setLanguage(language: Language) {
        this.store.dispatch(new ChangeLanguage(language));
    }

    async login() {
        await this.permissionService.login();
    }

    logout() {
        this.permissionService.logout()
    }
}
